import React from 'react';
import { Game } from '../types';

interface GameCardProps {
  game: Game;
  onPlayDemo: (game: Game) => void;
  onPlayReal: (game: Game) => void;
  onPlayRealViaUrl: (game: Game) => void;
  isAdmin?: boolean;
  onShowStats?: (gameId: number, gameName: string) => void;
}

const GameCard: React.FC<GameCardProps> = ({ game, onPlayDemo, onPlayReal, onPlayRealViaUrl, isAdmin, onShowStats }) => {
  const isInDevelopment = game.inDevelopment === true;
  
  return (
    <div className={`game-card ${isInDevelopment ? 'in-development' : ''}`}>
      {isInDevelopment && (
        <div className="development-badge">🚧 In Development</div>
      )}
      <div className="game-image">
        {game.image ? (
          <img src={game.image} alt={game.name} />
        ) : (
          <div className="placeholder-image">🎮</div>
        )}
      </div>
      <div className="game-info">
        <h3>{game.name}</h3>
        <p>{game.description || 'No description available'}</p>
        <div className="game-actions">
          <div className="game-actions-row">
            <button 
              className="btn btn-demo" 
              onClick={() => onPlayDemo(game)}
              disabled={isInDevelopment}
              title={isInDevelopment ? 'This game is currently in development' : ''}
            >
              Play Demo
            </button>
            <button 
              className="btn btn-real" 
              onClick={() => onPlayReal(game)}
              disabled={isInDevelopment}
              title={isInDevelopment ? 'This game is currently in development' : ''}
            >
              Play Real
            </button>
          </div>
          <button 
            className="btn btn-real-url" 
            onClick={() => onPlayRealViaUrl(game)}
            disabled={isInDevelopment}
            title={isInDevelopment ? 'This game is currently in development' : 'Play real money game via direct URL'}
            style={{
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '10px 20px',
              cursor: isInDevelopment ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              opacity: isInDevelopment ? 0.6 : 1,
              width: '100%',
              marginTop: '0.5rem'
            }}
          >
            Play Real (Direct URL)
          </button>
        </div>
        {isAdmin && onShowStats && (
          <div style={{ marginTop: '10px' }}>
            <button 
              className="btn btn-stats" 
              onClick={() => onShowStats(game.id, game.name)}
              style={{
                padding: '8px 16px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                width: '100%',
                fontWeight: '500'
              }}
            >
              📊 Statistics
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GameCard;
